import React, { useEffect } from 'react'
import { MetaSeo } from 'components/atoms'
import { HeaderLanding, Footer,  } from 'components/organisms'
import { OrganizationJsonLd } from 'next-seo'
import { DOMAIN, BRAND, LOGO_URL } from 'utils/settings'
import styles from './PageLanding.module.sass'

interface Props {
  pagina: any
  item?: any
  children: React.ReactNode
  className?: string
  contentClassName?: string
  theme?: {
    pageBgColor?: string
    heroBgColor?: string
    heroTextColor?: string
    primaryColor?: string
    primaryTextColor?: string
    headBgColor?: string
    footerBgColor?: string
    footerTextColor?: string
  }
  headerLogo?: string
  headerLogoAlt?: string
  footerHideStores?: boolean
}

const PageLanding = (props: Props) => {
  const {
    pagina = {},
    item = {},
    children = null,
    className = '',
    contentClassName = '',
    theme,
    headerLogo,
    headerLogoAlt,
    footerHideStores,
  } = props

  const themeStyle = {
    ...(theme?.pageBgColor ? { ['--landing-page-bg' as any]: theme.pageBgColor } : {}),
    ...(theme?.heroBgColor ? { ['--landing-hero-bg' as any]: theme.heroBgColor } : {}),
    ...(theme?.heroTextColor ? { ['--landing-hero-text' as any]: theme.heroTextColor } : {}),
    ...(theme?.primaryColor
      ? {
          ['--landing-primary' as any]: theme.primaryColor,
          ['--landing-primary-hover' as any]: theme.primaryColor,
        }
      : {}),
    ...(theme?.primaryTextColor
      ? { ['--landing-primary-contrast' as any]: theme.primaryTextColor }
      : {}),
    ...(theme?.headBgColor ? { ['--landing-head-bg' as any]: theme.headBgColor } : {}),
    ...(theme?.footerBgColor ? { ['--landing-footer-bg' as any]: theme.footerBgColor } : {}),
    ...(theme?.footerTextColor
      ? {
          ['--landing-footer-text' as any]: theme.footerTextColor,
          ['--landing-footer-border' as any]: theme.footerTextColor,
        }
      : {}),
  }

  const handleScroll = () => {
    if (window.scrollY > 0) document.body.classList.add('w-scrolled')
    else document.body.classList.remove('w-scrolled')
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className={styles.pageWrap} style={themeStyle}>
      <div className={`${styles.page} page ${className}`}>
        {pagina?.seo && <MetaSeo seo={pagina.seo} />}
        <HeaderLanding logoUrl={headerLogo} logoAlt={headerLogoAlt} />
        <main className={`${styles.content} ${contentClassName}`}>{children}</main>
        <Footer
          hideStores={footerHideStores}
          logoUrl={footerHideStores ? headerLogo : undefined}
          logoAlt={footerHideStores ? headerLogoAlt : undefined}
        />
      </div>
      
      <OrganizationJsonLd 
        name={BRAND}
        url={DOMAIN}
        logo={LOGO_URL}
        contactPoints={[
          {
            telephone: "800 73 73 40",
            contactType: "customer service",
            areaServed: "IT"
          }
        ]}
      />
    </div>
  )
}

export default PageLanding
